import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BlogListLayer from "../components/BlogListLayer";

const BlogListPage = () => {
    return (
        <MasterLayout>
            <BlogListLayer />
        </MasterLayout>
    );
};

export default BlogListPage;
